import React, { useState, useEffect } from 'react';

import * as flags from './config';

import './countryselect.css';

const debounceFnc = (fnc, tm = 550) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fnc.call(this, ...args);
    }, tm);
  }
}

const flagsItems = Object.entries(flags);


let setSearchDataDebounced;

const CountrySelect = ({onSelect}) => {
  const [search, setSearch] = useState('');
  const [searchData, setSearchData] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(()=>{
    // console.log('searchdata', searchData);
    if(searchData) {
      const search2=searchData.replace(/ /g,'_');
      const regex=new RegExp(search2,'i');
      const filtered=flagsItems.filter(([key,value])=>regex.test(key));
      // console.log('filtered',filtered);
      setFilteredItems(filtered);
    } else {
      setFilteredItems([]);
    }

    return ()=>{
      setSearchDataDebounced=null;
    }
  },[searchData]);

  const onChange = (fnc) => {
    return ({ target: { value } }) => {
      fnc(value);
      setSearchDataDebounced(value);
    }
  }

  const onClick=(countryData)=>{
    return ()=>{
      setSearch('');
      setFilteredItems([]);
      onSelect(countryData);
    }
  }

  if (!setSearchDataDebounced) setSearchDataDebounced = debounceFnc(setSearchData);


  let flagsItemsHtml = false;
  if (filteredItems.length) {

    flagsItemsHtml=filteredItems.map(([key,value],index)=>{
      const country = key.replace(/_/g,' ');
      return (
        <div onClick={onClick([country,value])} className="flag-select-item" key={'ctry-sel_'+index}>
          <img src={value} alt={key} />
          <p>{country}</p>
        </div>
      )
    })
  }

  return (
    <div className="country-select">
      <input type="text" className="textfield1" onChange={onChange(setSearch)} value={search} />
      <div className="country-select-items-wrapper">
        {flagsItemsHtml}
      </div>
    </div>
  )
}

export default CountrySelect;